export default __webpack_public_path__ + "static/media/bluetooth.df2dfcef.svg";